import React from 'react';
import { Typography, TypographyProps, Box, useTheme, Stack } from '@mui/material';
import { Tile, TileProps } from '../tile';

export interface CardProps extends Omit<TileProps, 'title'> {
    /**
     * The title of the component.
     */
    title: string;
    /**
     * The props to customize the title component
     */
    slotProps?: { typography: TypographyProps };
    /**
     * The image added at the top
     */
    image?: React.ReactNode | React.ReactNode[];
    /**
     * The primary action of the component.
     */
    primaryAction: React.ReactNode | React.ReactNode[];
    /**
     * The secondary action of the component.
     */
    secondaryAction?: React.ReactNode | React.ReactNode[];
}

export function Card({ title, slotProps, image, primaryAction, secondaryAction, ...otherProps }: CardProps) {
    const theme = useTheme();
    return (
        <Tile {...otherProps}>
            <Box marginBottom={(theme) => theme.spacing(theme.tokens.spacing.xs)}>{image}</Box>
            <Stack spacing={theme.spacing(theme.tokens.spacing.xl)}>
                <Stack spacing={theme.spacing(theme.tokens.spacing.sm)}>
                    <Typography variant="h5" {...slotProps?.typography}>
                        {title}
                    </Typography>
                    {otherProps.children}
                </Stack>
                <Box
                    display="flex"
                    flexDirection="row"
                    gap={(theme) => theme.spacing(theme.tokens.spacing.xs)}
                    flexWrap="wrap"
                >
                    {primaryAction}
                    {secondaryAction}
                </Box>
            </Stack>
        </Tile>
    );
}
